import React, { useContext, FC } from 'react';
import styled, { css, SimpleInterpolation, ThemeContext } from 'styled-components';
import { PlayCircle } from '@fenderdigital/ui/Icons';
import { Focus } from '@fenderdigital/ui/utils/css';

interface VideoPosterProps {
  poster?: string;
  onClick?: () => void;
}

interface ButtonContainerStyleProps {
  image?: string;
}

const ButtonContainer = styled.div<ButtonContainerStyleProps>`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  text-align: center;

  ${({ image }): SimpleInterpolation =>
    image &&
    css`
      background-image: url(${image});
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    `}
`;

const StyledPlayButton = styled.button`
  ${Focus}
`;

const VideoPoster: FC<VideoPosterProps> = ({ poster, onClick }) => {
  const { colors } = useContext(ThemeContext);

  return (
    <ButtonContainer data-id="video-poster" image={poster}>
      <StyledPlayButton data-id="play-button" onClick={onClick} aria-label="Play Video">
        <PlayCircle aria-hidden fill={colors.white} fontSize="8rem" />
      </StyledPlayButton>
    </ButtonContainer>
  );
};

export default VideoPoster;
